module.exports = __webpack_public_path__ + "static/media/galerija_2023 (21).249f4851.png";